import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgRestore = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0C2.68629 0 0 2.68629 0 6V14C0 17.3137 2.68629 20 6 20H14C17.3137 20 20 17.3137 20 14V6C20 2.68629 17.3137 0 14 0H6ZM13.5263 13.7895C12.5439 14.7719 11.3684 15.2632 10 15.2632C8.78947 15.2632 7.73263 14.8905 6.82947 14.1453C5.92561 13.3993 5.35088 12.4561 5.10526 11.3158H6.73684C6.98246 12 7.39474 12.566 7.97368 13.0137C8.55263 13.4607 9.22807 13.6842 10 13.6842C10.9474 13.6842 11.7544 13.3509 12.4211 12.6842C13.0877 12.0175 13.4211 11.2105 13.4211 10.2632C13.4211 9.31579 13.0877 8.50877 12.4211 7.84211C11.7544 7.17544 10.9474 6.84211 10 6.84211C9.52632 6.84211 9.07895 6.9386 8.6579 7.13158C8.23684 7.32456 7.87719 7.57895 7.57895 7.89474H9.47368V9.47368H5V5H6.57895V6.63158C7.03509 6.21053 7.55263 5.87719 8.13158 5.63158C8.71053 5.38597 9.33333 5.26316 10 5.26316C11.3684 5.26316 12.5439 5.75439 13.5263 6.73684C14.5088 7.7193 15 8.89474 15 10.2632C15 11.6316 14.5088 12.807 13.5263 13.7895Z"
      fill="#CCC2DC"
    />
  </svg>
);

export default SvgRestore;
